
export default function Footer() {
  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/72187a25-def1-4356-ac53-62c960b600d4.png"
              alt="Sonoma Routes"
              className="h-10 w-auto mb-4"
            />
            <p className="text-sm text-gray-600">
              Local snack distribution for independent stores in Sonoma County.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-gray-900 mb-4">Company</h4>
            <ul className="space-y-2">
              <li>
                <a href="#who-we-serve" className="text-sm text-gray-600 hover:text-gray-900 cursor-pointer">
                  Who We Serve
                </a>
              </li>
              <li>
                <a href="#products" className="text-sm text-gray-600 hover:text-gray-900 cursor-pointer">
                  Products
                </a>
              </li>
              <li>
                <a href="#how-it-works" className="text-sm text-gray-600 hover:text-gray-900 cursor-pointer">
                  How It Works
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-gray-900 mb-4">Get Started</h4>
            <ul className="space-y-2">
              <li>
                <a href="#store-inquiry" className="text-sm text-gray-600 hover:text-gray-900 cursor-pointer">
                  Store Inquiry
                </a>
              </li>
              <li>
                <a href="#producer-inquiry" className="text-sm text-gray-600 hover:text-gray-900 cursor-pointer">
                  Producer Inquiry
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-gray-900 mb-4">Contact</h4>
            <ul className="space-y-2">
              <li className="text-sm text-gray-600">Sonoma County, California</li>
              <li>
                <a href="mailto:info@sonomaroutes.com" className="text-sm text-gray-600 hover:text-gray-900 cursor-pointer">
                  info@sonomaroutes.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-600 mb-4 md:mb-0">
            © 2025 Sonoma Routes. All rights reserved.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gray-600 hover:text-gray-900 cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
